import { Magic } from "magic-sdk";
import { NearExtension } from "@magic-ext/near";

export const magic =
  typeof window !== "undefined"
    ? new Magic(process.env.GATSBY_MAGIC_LINK_API_KEY, {
      extensions: [new NearExtension({ rpcUrl: "" })],
    })
    : null;